










import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SeksiPenyakitDetail extends Vue {
  @Prop({ default: () => ({}) }) data!: any;

  formatYaTidak(val: string, useTahu = false) {
    if (!val) return "-";
    if (useTahu) {
      return val === "tahu" ? "Tahu" : "Tidak";
    }
    return val === "ya" ? "Ya" : "Tidak";
  }

  get formatSumberInfo() {
    const sources: string[] = [];
    const info = this.data.sumber_info || [];
    if (info.includes("dokter")) sources.push("Dokter");
    if (info.includes("perawat")) sources.push("Perawat");
    if (info.includes("keluarga")) sources.push("Keluarga");
    if (this.data.sumber_info_lainnya) sources.push(this.data.sumber_info_lainnya);
    return sources.length ? sources.join(", ") : "-";
  }
}
